import { 
  // AuthError, 
  // EventType, 
  PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from '@/modules/authentication/authConfig';
// import { logger } from '@common/logging/logger';

export const msalInstance = new PublicClientApplication(msalConfig);

// Logging for MSAL
// msalInstance.addEventCallback(({ eventType, error }) => {
// 	if (error) {
// 		logger.error('[MSAL] authentication event failed', {
// 			eventType,
// 			errorCode: error instanceof AuthError ? error.errorCode : error.name,
// 			correlationId: error instanceof AuthError ? error.correlationId : undefined,
// 		});
// 		return;
// 	}

// 	if (
// 		eventType === EventType.INITIALIZE_END ||
// 		eventType === EventType.HANDLE_REDIRECT_START ||
// 		eventType === EventType.HANDLE_REDIRECT_END ||
// 		eventType === EventType.LOGIN_SUCCESS
// 	) {
// 		logger.info('[MSAL] authentication lifecycle', eventType);
// 	}
// });
